// @flow
import NinePartsTable from './NinePartsTable';

export default NinePartsTable;
